import script from "./LayoutSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutSlide.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__